import { createEffect } from 'effector';

import { apiFetch } from '@m/utils/http';

import type { WhitelistedEmailForm } from '@m/types/api';

export const getWhitelistedEmails = createEffect({
  handler: ({ subscriptionPlanId }: { subscriptionPlanId: number }) =>
    apiFetch(`/admin/subscription/plan/${subscriptionPlanId}/whitelisted-emails`),
});

export const addWhitelistedEmails = createEffect({
  handler: ({
    subscriptionPlanId,
    whitelistedEmailForm,
  }: {
    subscriptionPlanId: number;
    whitelistedEmailForm: WhitelistedEmailForm;
  }) =>
    apiFetch(`/admin/subscription/plan/${subscriptionPlanId}/whitelisted-emails`, {
      method: 'POST',
      body: whitelistedEmailForm,
    }),
});

export const deleteWhitelistedEmailByEmail = createEffect({
  handler: ({
    whitelistedEmail,
    subscriptionPlanId,
  }: {
    subscriptionPlanId: number;
    whitelistedEmail: string;
  }) =>
    apiFetch(
      `/v2/admin/subscription/plan/${subscriptionPlanId}/whitelisted-email/${whitelistedEmail}`,
      {
        method: 'DELETE',
      },
    ),
});
